export default __webpack_public_path__ + "static/media/diary.2dddeb9e.svg";